import React from 'react';
import AgreementsPageContent from '../../Agreements/Components/AgreementsPageContent';

export default function AgreementsPage() {
    return <AgreementsPageContent />;
}
